/* tslint:disable */
/* eslint-disable */

/**
 * 0 = Standard
 * 
 * 1 = RepeatCustom
 * 
 * 2 = Custom
 * 
 * 3 = Calibration
 * 
 * 4 = Hire
 * 
 * 5 = Marine
 */
export enum DealType {
  Standard = 0,
  RepeatCustom = 1,
  Custom = 2,
  Calibration = 3,
  Hire = 4,
  Marine = 5
}
